import * as plugins from './plugins.js';
import './elements/maintainable-page.js';

const run = async (): Promise<void> => {
  await plugins.deesDomtools.DomTools.setupDomTools();
  plugins.serviceworker.getServiceworkerClient();

  plugins.deesElement.render(
    plugins.deesElement.html`<maintainable-page></maintainable-page>`,
    document.body,
  );
};

await run();
